import { mergeProps } from '@zag-js/solid';
import { ark } from '../factory';
import { useDatePickerContext } from './use-date-picker-context';
export const DatePickerRangeText = (props) => {
    const api = useDatePickerContext();
    const mergedProps = mergeProps(() => api().getRangeTextProps(), props);
    return <ark.div {...mergedProps}>{api().visibleRangeText.start}</ark.div>;
};
